import React from 'react';
import { useTranslation } from 'react-i18next';

/** Pied de page marque : icône livre + titre (i18n). */
export default function AppFooter() {
  const { t } = useTranslation();
  return (
    <footer
      style={{
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        padding: '14px 16px',
        backgroundColor: '#ecf0f1',
        color: '#2c3e50',
        borderTop: '1px solid #dfe6e9',
        fontSize: 15,
        fontWeight: 600,
      }}
    >
      <svg
        width={22}
        height={22}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
      </svg>
      <span>{t('brand.title')}</span>
    </footer>
  );
}
